import { useAuthStore } from "~/stores/auth"

export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore()
  const api = $fetch.create({

    onRequest({ request, options, error }) {
      if (authStore.token && authStore.token !== null) {
        const headers = options.headers ||= {}
        if (Array.isArray(headers)) {
          headers.push(['Authorization', `Bearer ${authStore.token}`])
        } else if (headers instanceof Headers) {
          headers.set('Authorization', `Bearer ${authStore.token}`)
        } else {
          headers.Authorization = `Bearer ${authStore.token}`
        }
      }
    },
    async onResponseError({ response }) {
      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo('/login'))
      }
    }
  })

  const apiSearch = $fetch.create({})

  return {
    provide: {
      api,
      apiSearch
    }
  }
}
)